import * as d3 from 'd3-selection'
import fontSize from './font-size.js'
import tweener from './text-tween.js'
import yPos from './y-text-position.js'
import * as colors from 'scoreboard-colors'

const width = 25
const borderRadius = 2
// we want slightly smaller padding than the global padding
const paddingOverridePercent = 0.75

const font = function (d, i, all) {
  if (i) {
    // 2nd line
    // Actual font sizes might be set by a transition
    // Use the defined data-fs font size (which is the end state)
    return d3.select(all[0]).attr('data-fs')
  } else {
    let num = all.length == 1 ? 9 : 7 // Two lines, smaller font sizes
    return fontSize(this, d.text, '', width / 2, num)
  }
}

export default function (id, dim) {
  let translateX = dim.viewbox.width - width - (dim.padding.right * paddingOverridePercent)

  let draw = function (selection) {
    selection.each(function (d) {
      let change = d3.select(this)
                     .selectAll('g.change').data(function (d) {
                       return d.change && !d.explanation ? [d.change] : []
                     })
      let enter = change.enter()
                        .append('g')
                          .attr('class', 'change')
        , _change = enter.merge(change)
                         .attr('transform', 'translate(' + translateX + ',' + 0 + ')')
                         .attr('class', 'change')

      // Background colored rect of the change component

      _change.selectAll('rect')
        .data(d => [d])
        .join('rect')
           .attr('width', width)
           .attr('height', dim.header.height)
           .attr('rx', borderRadius)
           .attr('ry', borderRadius)
           .style('fill', d => d.color)

      // Add a group for positioning the text
      let textGroup = _change.selectAll('g.text-group-change').data(d => [d])
        , _textGroup = textGroup.enter()
                                .append('g')
                                  .attr('class', 'text-group-change')
                                  .merge(textGroup)
                                  .attr('transform', `translate(${width / 2},0)`)

      // Text labels inside of the rect
      let text = _textGroup.selectAll('text')
                        .data(d => {
                          // See https://github.com/SpiderStrategies/Scoreboard/issues/39066
                          let formatted = d.formatted || ''
                            , re = /\s+(?=\D+)/ // Split on a space followed by a character (not a digit)
                            , text = formatted.split(re)
                            , variation = colors.getTextVariation(d.color)

                          return text.map(text => {
                            return { text, variation }
                          })
                        })
      text.enter()
          .append('text')
          .text(d => d.text)
          .attr('class', 'label-on-colored-background')
          .attr('data-fs', font) // Set the defined font size immediately, b/c two lines depend on each other
          .style('font-size', font)
          .attr('y', function () {
            return yPos(parseFloat(d3.select(this).style('font-size')), dim.header.height)
          })
          .merge(text)
          .classed('light', d => d.variation === 'light')
          .classed('dark', d => d.variation === 'dark')
          .attr('dy', (d, i, all) => {
            if (all.length === 1) {
              return 0
            } else {
              // Two lines, move the first line up and the bottom line down
              let offset = .5 * (i ? 1 : -1)
              return `${offset}em`
            }
          })
          .attr('data-fs', font)
          .transition()
          .duration(300)
          .tween('change-text-tween', function (d) {
            return tweener.call(this, d.text, dim)
          })

      change.exit()
             .remove()
    })
  }

  return draw
}
